module.exports = __webpack_public_path__ + "static/media/minus-hexagon.099535c8.svg";